// Module
var code = "<react-component name=\"GymList\" props=\"{\nsetTab: setTab,\n}\"></react-component>\n";
// Exports
module.exports = code;